import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { useLogout } from '../hooks/auth-actions.js';
import { DEFAULT_FORM_CLASSES } from './shared.js';
/**
 * Calls `/auth/logout` on click and fires the optional `onLoggedOut` callback.
 * The button is disabled while the request is in flight; failures fall through
 * silently because the local token is cleared regardless of server status.
 */
export function LogoutButton({ variant = 'primary', className, onLoggedOut, children = 'Sign out', }) {
    const action = useLogout();
    const baseClass = variant === 'link'
        ? DEFAULT_FORM_CLASSES.link
        : variant === 'secondary'
            ? DEFAULT_FORM_CLASSES.secondaryButton
            : DEFAULT_FORM_CLASSES.button;
    const handleClick = async () => {
        try {
            await action.run();
        }
        catch {
            // Deliberately swallowed, and this `catch` is the fix for a real defect rather than
            // defensive noise: `useAsyncAction.run` **rethrows** after capturing, and this handler is
            // passed straight to `onClick`, so React drops the rejected promise on the floor — a server
            // that refuses the logout produced an *unhandled rejection* in the member's browser.
            //
            // Nothing here should surface it. `auth-client.logout()` clears the stored token in a
            // `finally`, so the outcome the person asked for has already happened; the only thing left
            // to report is that the server was not told, which is not theirs to act on. The `finally`
            // below still runs either way, which is what makes the redirect unconditional.
        }
        finally {
            onLoggedOut?.();
        }
    };
    return (_jsx("button", { type: "button", className: clsx(baseClass, className), onClick: handleClick, disabled: action.loading, children: action.loading ? 'Signing out…' : children }));
}
//# sourceMappingURL=LogoutButton.js.map